export { Spline, SplineProps, Domain as SplineDomain, Ticks as SplineTicks } from './Spline';
